import React, { useContext } from "react";

import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { getCurrentCulture } from "@utils";
import { OfferStoreContext } from "@gp/components";

import { DefaultPath } from "@utils/common/defaultRoutePathsEnum";

import { redirect } from "@state";
import { SearchAction } from "@state/stores/offer/search/SearchStore";

export const SearchHeader = observer(function SearchHeader(props: {
	searchTerm: string;
}) {
	const { searchTerm } = props;

	const { t } = useTranslation();

	const {
		// @ts-expect-error
		rootStore: {
			searchBarViewStore: { onReset: onSearchTermReset },
		},

		// @ts-expect-error
		searchElementsCount,
		//@ts-expect-error
		params,
	} = useContext(OfferStoreContext);

	const shouldDisplayResults =
		Number(params?.action) == SearchAction.SEARCH ||
		Number(params?.action) == SearchAction.PICK_FIRST;

	return (
		<div className="header--search">
			<div className="header--search__title">
				{shouldDisplayResults && (
					<>
						<div className="title--primary">
							{t<string>("SEARCH.TITLE", { searchTerm })}
						</div>
						<span className="counter counter--lrg counter--dark--outlined u-mar--left--xsml">
							{searchElementsCount}
						</span>
					</>
				)}
			</div>
			<button
				className="header--search__btn btn btn--square btn--square--sml btn--primary--inverted btn--animate-grow"
				type="button"
				onClick={() => {
					onSearchTermReset();
					redirect(`/${getCurrentCulture()}/${DefaultPath.HOME}`);
				}}
			>
				<i className="u-icon u-icon--tny u-icon--close" />
			</button>
		</div>
	);
});
